<template>
    <div>
        <div>
            <img :src="this.$route.params.img" alt="">
        </div>
    </div>
</template>

<script>
export default{
  name: 'IntroductionPage',
  data() {
    return {
      
    }
  },
  created() {
    console.log('IntroductionPage',this.$route.params.img);
  },
  methods: {
    
  }
}
</script>

<style scoped>

</style>